export class Global {
  public static BASE_RESETCONFIRM_ENDPOINT = 'api/Authorization/ResetPasswordConfirm';
  public static BASE_RESETPASSWORD_ENDPOINT = 'api/Authorization/resetpassword';
  public static BASE_GETINITIAL_USERINFO_ENDPOINT = 'api/account/GetInitialUserInfo';
  public static BASE_TOKENCONFIRM_ENDPOINT = 'api/Authorization/confirmtoken';
  public static BASE_GET_DARK_FEATURE_ENDPOINT = 'api/App/GetDarkFeatures';
  public static BASE_GET_SCHEDULED_MAINTANANCE_ENDPOINT = 'api/App/GetScheduledMaintenance';
  public static BASE_ACCOUNT_ORGS_ENDPOINT = 'api/Account/GetUserOrganizations';
  public static BASE_ACCOUNT_CHANGEPASSWORD_ENDPOINT = 'api/Account/changepassword';
  public static BASE_PASSWORD_EXISTS_ENDPOINT = 'api/Account/IsPwdUsed';
  public static BASE_GET_DOCUMENTS_ENDPOINT = 'api/eds/GetEdsDocs';
  public static BASE_GET_DOCUMENT_ENDPOINT = 'api/eds/GetEdsDocById';
  public static BASE_GET_MEM_DOC_HISTORY_ENDPOINT = 'api/uploads/GetMemberDocHistory';

  // PAYROLL URL
  public static BASE_IMPORT_ENDPOINT = 'api/Import/GetImport';
  public static BASE_IMPORT_FROM_FILE_ENDPOINT = 'api/import/ImportFromFile';
  public static BASE_IMPORT_DELETE_ENDPOINT = 'api/Import/DeleteImport';
  public static BASE_IMPORT_DELETE_UNSUB_IMPORT_ENDPOINT = 'api/Import/DeleteUnValidatedImports';
  public static BASE_IMPORT_PPEDEXISTS_ENDPOINT = 'api/Import/IsPpedExists';
  public static BASE_IMPORT_CLONE_ENDPOINT = 'api/Import/CloneImport';
  public static BASE_IMPORT_CONTINUE_UPLOAD_ENDPOINT = 'api/Import/ContinueUpload';
  public static BASE_IMPORT_PRESUBMIT_ENDPOINT = 'api/import/PreSubmitImport';
  public static BASE_IMPORT_SUBMIT_IMPORT_ENDPOINT = 'api/Import/SubmitImport';
  public static BASE_RECORD_ENDPOINT = 'api/import/GetRecords';
  public static BASE_USERLOCATION_ENDPOINT = 'api/Location/GetOrgUserLocations';
  public static BASE_RECORD_DELETE_ENDPOINT = 'api/import/DeleteRecord';
  public static BASE_ISSUE_RECORD_ENDPOINT = 'api/import/GetIssuePayrollRecords';
  public static BASE_FILE_DOWNLOAD_ENDPOINT = 'api/import/TextFileDownLoad';
  public static BASE_IMPORT_ERRORS_ENDPOINT = 'api/Import/GetErrorCounts';
  public static BASE_IMPORT_ISSUE_ENDPOINT = 'api/Import/GetIssuesList';
  public static BASE_STATES_ENDPOINT = 'api/Import/GetStates';
  public static BASE_ENROLLMENT_AUTHORIZED_STATES_ENDPOINT = 'api/Enrollments/GetStates';
  public static BASE_IMPORT_VALIDATIONS_ENDPOINT = 'api/Import/GetValidationSettings';
  public static BASE_RECORD_CREATE_ENDPOINT = 'api/import/CreateRecord';
  public static BASE_RECORD_UPDATE_ENDPOINT = 'api/import/UpdateRecord';

  // ADJUSTMENTS URL
  public static BASE_GET_ADJUSTMENT_HISTORY_ENDPOINT = 'api/Adjustments/GetAdjustmentHistory';
  public static BASE_POST_ADJUSTMENT_RECORDS_ENDPOINT = 'api/Adjustments/CreateAdjustment';
  public static BASE_GET_ADJUSTMENT_RECORDS_ENDPOINT = 'api/Adjustments/GetAdjustment';
  public static BASE_ADJUSTMENT_DELETE_ENDPOINT = 'api/Adjustments/DeleteAdjustment';
  public static BASE_VIEW_ADJ_FILE_ENDPOINT = 'api/Adjustments/GetAdjustmentFile';

  // ADJUSTMENT REPORTS V2 URL
  public static BASE_GET_ADJUSTMENT_V2_RECORDS_ENDPOINT = 'api/Adjustments/GetPayrollAdjustment';
  public static BASE_GET_ADJUSTMENT_V2_DETAILS_ENDPOINT = 'api/Adjustments/GetPayrollAdjustmentRecordsBySSN';
  public static BASE_GET_ADJUSTMENT_INPUTS_ENDPOINT = 'api/Adjustments/GetAdjustmentInputs';
  public static BASE_SUBMIT_ADJUSTMENT_DATA_ENDPOINT = 'api/Adjustments/SubmitPayrollAdjustment';
  public static BASE_ADJUSTMENT_FILE_UPLOAD_ENDPOINT = 'api/Adjustments/UploadAdjustmentFile';
  public static BASE_ADJ_RECORD_CREATE_ENDPOINT = 'api/Adjustments/CreatePayrollAdjustment';
  public static BASE_ADJ_RECORD_UPDATE_ENDPOINT = 'api/Adjustments/UpdateAdjustmentRecord';
  public static BASE_ADJ_RECORD_DELETE_ENDPOINT = 'api/Adjustments/DeleteAdjustmentRecord';
  public static BASE_ADJ_REPORT_DELETE_ENDPOINT = 'api/Adjustments/DeleteAdjustmentReport';
  public static BASE_GET_PAYROLL_ADJ_REPORTS_ENDPOINT = 'api/Adjustments/GetPayrollAdjustmentReports';
  public static BASE_GET_ADJ_OWNER_LIST_ENDPOINT = 'api/Adjustments/GetAdjustmentUsers';
  public static BASE_UPDATE_ADJ_OWNER_ENDPOINT = 'api/Adjustments/UpdateAdjustmentOwner';
  public static BASE_GET_EMPLOYEE_DETAILS_ENDPOINT = 'api/Adjustments/GetEmployeeDetails';
  public static BASE_GET_REJECTED_ADJUSTMENT_ENDPOINT = 'api/Adjustments/GetRejectedPayrollAdjustmentRecords';
  public static BASE_DLT_REJECTED_ADJUSTMENT_ENDPOINT = 'api/Adjustments/DeleteRejectedPayrollAdjRecords';
  public static BASE_MOVE_REJECTED_ADJUSTMENT_ENDPOINT = 'api/Adjustments/MoveRejectedPayrollAdjRecords';
  public static BASE_GET_CORRESPONDING_ADJ_V2_DETAILS_ENDPOINT = 'api/Adjustments/GetEmploymentDataForAdjRecord';

  // UPLOAD URL
  public static BASE_PM_UPLOAD_ENDPOINT = 'api/uploads/getuploadshistory';
  public static BASE_PM_UPLOAD_LOC_ENDPOINT = 'api/uploads/getuserlocations';
  public static BASE_PM_UPLOAD_FILECAT_ENDPOINT = 'api/uploads/getFileCategories';
  public static BASE_PM_UPLOAD_FROMFILE_ENDPOINT = 'api/Uploads/ImportFromFile';

  // USERS URL
  public static BASE_VALIDATE_EMAIL_ENDPOINT = 'api/User/IsEmailValid';
  public static BASE_ROLES_LIST_ENDPOINT = 'api/Account/GetAppRoles';
  public static BASE_CONTACT_ROLES_LIST_ENDPOINT = 'api/Account/GetContactAppRoles';
  public static BASE_USER_ENDPOINT = 'api/Account/GetUsers';
  public static BASE_USER_ENDPOINT_ADDNEW = 'api/Account/AddNew';
  public static BASE_USER_ENDPOINT_UPDATE = 'api/Account/UpdateUser';
  public static BASE_ALL_USER_ENDPOINT = 'api/Account/GetUserById';
  public static BASE_UPDATE_CURRENT_USER_ENDPOINT = 'api/Account/UpdateCurrentUser';
  public static BASE_DLT_USERS_USER_ENDPOINT = 'api/Account/DeactivateUser';

  // NEW
  public static BASE_USER_BY_USERNAME = 'api/account/users/username';
  public static BASE_CURRENT_USER_URL = 'api/account/users/me';
  public static BASE_CURRENT_USER_PREFERENCES_URL = 'api/account/users/me/preferences';
  public static BASE_USER_ENDPOINT_UPDATE_CURRENT = 'api/Account/UpdateCurrentUser';
  public static BASE_UNBLOCK_USER_URL = 'api/account/users/unblock';
  public static BASE_USER_ROLES_URL = 'api/account/roles';
  public static BASE_ROLE_BY_ROLENAME_URL = 'api/account/roles/name';
  public static BASE_PERMISSIONS_URL = 'api/account/GetPermissions';

  // Account URL
  public static BASE_GET_CURRENT_USER_ENDPOINT = 'api/account/users/me';

  // Org Location profile
  public static BASE_ALL_ORGINFO_ENDPOINT = 'api/Location/ViewOrganizationInfo';

  // News
  public static BASE_GET_NEWS_ENDPOINT = 'api/news/GetSharePointNews';
  public static BASE_GET_NEWS_BY_ID_ENDPOINT = 'api/news/GetSharePointNewsById';

  // Task Tracker
  public static BASE_GET_TRACKER_TASK_ENDPOINT = 'api/tasktracker/gettasks';
  public static BASE_POST_UPDATE_TERMINATE_TASK_ENDPOINT = 'api/TaskTracker/UpdateTask';

  // Cutoff Notices
  public static BASE_GET_CUTOFF_NOTICES_ENDPOINT = 'api/CutoffNotices/GetCutoffNotices';

  // Enrollments
  public static BASE_GET_ENROLLMENT_INFO_BY_SSN_ENDPOINT = 'api/Enrollments/GetEnrollmentInfoBySSN'
  public static BASE_GET_ENROLLMENT_PERSON_INFO_ENDPOINT = 'api/Enrollments/GetUserBySsn';
  public static BASE_SAVE_PERSON_INFO_ENDPOINT = 'api/Enrollments/PersonalInfo';
  public static BASE_GET_ENROLLMENT_LOC_AND_SYS_ENDPOINT = 'api/Enrollments/GetEnrollmentsTwoInputs';
  public static BASE_GET_ENROLLMENT_PAY_SCHEDULE_ENDPOINT = 'api/Enrollments/GetEnrollmentsTwoPaySchedules';
  public static BASE_SAVE_SCHEDULE_INFO_ENDPOINT = 'api/Enrollments/ScheduleInfo';
  public static BASE_SAVE_CONTACT_INFO_ENDPOINT = 'api/Enrollments/ContactInfo';
  public static BASE_DOWNLOAD_UPLOADED_FILE_ENDPOINT = 'api/Enrollments/DownloadEnrollmentsFile';
  public static BASE_GET_PENDING_ENROLLMENTS_HISTORY_DATA_ENDPOINT = 'api/Enrollments/GetEnrollmentHistory';
  public static BASE_UPDATE_ENROLLMENT_RECORD_OWNER_ENDPOINT = 'api/Enrollments/AssignEnrollment';
  public static BASE_PENDING_ENROLL_RECORD_DELETE_ENDPOINT = 'api/Enrollments/DeleteEnrollment';

  // bank account info
  public static BASE_GET_EMP_BANK_INFO_ENDPOINT = 'api/payments/GetEmployerBankInfo';
  public static BASE_GET_BANK_NAME_ENDPOINT = 'api/payments/GetBankInfo';
  public static BASE_UPDATE_BANK_INFO_ENDPOINT = 'api/payments/AddOrUpdateEmpBankInfo';

  // UPLOAD
  public static BASE_UPLOAD_MEMBER_DOC_BATCH_ENDPOINT = 'api/uploads/UploadMemberDocBatch';

  // Const values
  public static ApplicationName = 'Payroll Reporting';
  public static OrgAbbr = 'MSRA';
  public static OrganizationName = 'Maryland State Retirement Agency';
  public static DisplayErrorMessage = 'Unknown Error : Please contact system support.';

  // SCHEDULE URLS
  public static BASE_SCHEDULE_ENTRIES_ENDPOINT = 'api/schedule/GetScheduleEntries';
  public static BASE_LOAD_SCHEDULE_ENDPOINT = 'api/schedule/LoadSchedule';
  public static BASE_FISCAL_YEAR_LIST_ENDPOINT = 'api/schedule/GetScheduleFYs';
  public static BASE_SCHEDULE_LIST_ENDPOINT = 'api/schedule/GetScheduleList';
  public static BASE_INPUT_SCHEDULE_ENDPOINT = 'api/schedule/GetScheduleInputs';
  public static BASE_CONTINUE_SCHEDULE_ENDPOINT = 'api/schedule/LoadPartialSchedule';
  public static BASE_GENERATE_SCHEDULE_ENDPOINT = 'api/schedule/Generate';
  public static BASE_DELETE_SCHEDULE_ENDPOINT = 'api/schedule/Delete';
  public static BASE_UPDATE_SCHEDULE_ENDPOINT = 'api/schedule/Update';
  public static BASE_GET_HOLIDAYS_ENDPOINT = 'api/schedule/Holidays';
  public static BASE_SAVE_SCHEDULE_ENDPOINT = 'api/schedule/PayScheduleSave';
  public static BASE_SCHEDULE_NAME_EXISTS_ENDPOINT = 'api/schedule/NameExists';
  public static BASE_SCHEDULE_ID_EXISTS_ENDPOINT = 'api/schedule/EmpScheduleIdExists';
  public static BASE_UPDATE_SCHEDULE_ID_EXISTS_ENDPOINT = 'api/schedule/UpdateEmpScheduleId';

  // EMPLOYEE
  public static BASE_GET_EMPLOYEE_INFO_ENDPOINT = 'api/Employees/GetEmployeeDetails';
  public static BASE_GET_ORG_LIST_DATA_ENDPOINT = 'api/Employees/GetUserOrgAndRoleList';
  public static BASE_POST_TERMINATE_EMP_DATA_ENDPOINT = 'api/Employees/UpdateEmployeeTermination';
  public static BASE_GET_ENROLLMENT_SALARY_INFO_ENDPOINT = 'api/Employees/GetEnrollmentSalaryData';
    
  // invoice
  public static BASE_GET_PAST_DUE_INVOICES_ENDPOINT = 'api/invoice/GetPastDueInvoices';
  public static BASE_GET_DUE_INVOICES_ENDPOINT = 'api/invoice/GetDueInvoices';
  public static BASE_GET_PENDING_INVOICES_ENDPOINT = 'api/invoice/GetInprogressInvoices';
  public static BASE_GET_PAID_INVOICES_ENDPOINT = 'api/invoice/GetPaidInvoices';
  public static BASE_CREATE_INVOICE_ENDPOINT = 'api/invoice/CreateInvoice';
  public static BASE_SUBMIT_PAYMENT_ENDPOINT = 'api/invoice/SubmitPayment';
  public static BASE_CHECK_BANK_INFO_ENDPOINT = 'api/invoice/GetEmpACHStatus';
  public static BASE_VIEW_PAID_INVOICE_ENDPOINT = 'api/eds/GetInvoiceDocument';
  public static BASE_SCHEDULE_PAYMENT_ENDPOINT = 'api/invoice/ProcessScheduledInvoices';

  // secure messages
  public static BASE_GET_MESSAGETOPICS_ENDPOINT = 'api/Message/GetMessageTopics';
  public static BASE_GET_SECUREMESSAGES_ENDPOINT = 'api/Message/GetSecureMessages';
  public static BASE_SEND_MESSAGE_ENDPOINT = 'api/Message/SendMessage';
  public static BASE_DELETE_MESSAGE_ENDPOINT = 'api/Message/DeleteMessage';
  public static BASE_READ_MESSAGE_ENDPOINT = 'api/Message/ReadMessage';
  public static BASE_GET_UNREADMESSAGE_COUNT_ENDPOINT = 'api/Message/GetUnreadMessageCount';
}
